'use strict';
/**
 * 分布图层的基类；子类包括点、线、面
 * @module DistributeLayer
 */
define([
    './BaseLayer',
    '../utils/CommonUtil',
    '../utils/GeometryUtil',
    './LayerExtend',
    '../utils/LoggerUtil',
    '../utils/RenderUtil',
    '../g2'
],function(
    BaseLayer,
    CommonUtil,
    GeometryUtil ,
    layerExtend,
    LoggerUtil,
    RenderUtil,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 分布图层基类
     * @augments G.lys.BaseLayer
     * @alias G.lys.DistributeLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {String} options.idKey - 必填，数据记录中作为唯一标识的字段名
     * @param {String} options.attributeField - 可选，数据记录中属性信息挂接的属性名，默认为空
     * @param {String} options.geometryField - 可选，数据记录中空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUDE
     * @param {Object} options.symbolConfig - 必填，符号配置
     * @param {String} options.defaultSymbolKey - 可选，符号配置文件中默认符号的key值，默认为default
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认4326
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认图层坐标系
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} 实例化的对象
     */
    var layer=BaseLayer.extend({
        options:{
            //数据的主键字段名
            idKey:'id',
            //属性字段在数据对象的哪个属性对象中；不配置或者为空表示属性直接挂在数据对象下；默认为空；
            attributeField:'',
            geometryField:null,//存储wkt或者geojson的字段名；此项优先级高于xField,yField;
            //样式配置文件路径
            symbolConfigUrl:'',
            //默认符号的key值
            defaultSymbolKey:'default'
        },
        initialize:function(options){
            BaseLayer.prototype.initialize.call(this,options);
            //记录当前对象的类型
            this.type=this.constructor.type;
            //符号配置
            if(CommonUtil.isObject(this.options.symbolConfig)){
                this.symbolConfig=jQuery.extend(true,{},this.options.symbolConfig);
                delete this.options.symbolConfig;
            }
            //分布图层
            this.layer=new g2.carto.ElementLayer({
                id:this.options.layerId,
                name:this.options.layerName||'',
                map: this.map
            });
            //获取id的方法,性能优化
            if(this.options.idKey.indexOf('.')<0){
                this._getRecordId=function(data){
                    return data[this.options.idKey];
                }
            }else{
                this._getRecordId=function(data){
                    // return data[this.options.idKey];
                    if(data){
                        var attrs=this.options.idKey.split('.'),
                            value=data;
                        if(attrs.length>0){
                            for(var k=0,len=attrs.length;k<len;k++){
                                var attrKey=attrs[k];
                                if(!!value&&!!attrKey){
                                    value=value[attrKey];
                                }else{
                                    value=null;
                                    break;
                                }
                            }
                        }
                        if(value!=null){
                            return value;
                        }else{
                            LoggerUtil.error('fail to  get id of ' +JSON.stringify(data));
                        }
                    }
                }
            }
            /***
             * 保存当前图层展示的所有不同符号的key值、符号对象、符号说明；
             * 用于记录有多少种显示的符号；
             * 可提供给图例使用；
             */
            this.currentSymbols=[];
            /***
             * 保存当前图层所有可能的符号的key值、符号对象、符号说明；
             * @type {Array}
             */
            this.allSymbols=[];
            /***
             * 保存当前图层渲染的字段和值
             *
             */
            this.renderFields=[];
            //获取符号配置
            this._getSymbolCfg();
            //wkt解析器
            var geomFactory=new jsts.geom.GeometryFactory(new jsts.geom.PrecisionModel(100000));
            this.wktReader=new jsts.io.WKTReader(geomFactory);
        },
        /***
         * 添加监听
         * @private
         */
        _addListeners:function(){
            BaseLayer.prototype._addListeners.call(this);
            //
            this.map.listen('click',this._mapClickListener,this);
        },
        /***
         * 移除监听
         * @private
         */
        _removeListeners:function(){
            this.map.off('click',this._mapClickListener,this);
            //
            BaseLayer.prototype._removeListeners.call(this);
        },

        /***
         * 鼠标滑过事件
         * @returns {layer._mapMouseMoveListener|*}
         * @private
         */
        _mapClickListener:function(event){
            var ele=this.hitTest(event.screenX, event.screenY);
            if(ele){
                this.fire('click',{
                    element:ele.element,
                    layer:ele.layer
                });
            }
        },
        /***
         *  创建符号
         * @param type
         * @param options
         * @returns {*}
         * @private
         */
        _createSymbol:function(type,options){
            return RenderUtil.object2Symbol(type,options);
        },
        /**
         * 批量添加元素
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Array} dataArr - 必填，数据数组
         * @param {Object} options - 可选，参数
         * @param {Number} options.dataSpatialReference - 可选，数据的坐标系
         */
        addElements:function(dataArr,options){

        },
        /**
         * 获取几何对象
         * @method
         * @param {Object} data
         * @param {Number} srcSpatialReference - 叠加的坐标系
         * @param {Number} destSpatialReference - 数据源坐标系
         * @returns {Object}
         */
        _getGeometry:function(data,srcSpatialReference,destSpatialReference){
            if(!data){
                return null;
            }
            var geometryField=this.options.geometryField,geometry=null;
            try{
                if(geometryField){
                    var geometryObj=data[geometryField];
                    try{
                        if(typeof geometryObj=='string'){
                            geometryObj=this.wktReader.read(geometryObj).toString();
                            geometry=g2.sfs.GeometryFactory.createGeometryFromWkt(geometryObj,srcSpatialReference);
                        }else{
                            geometry=g2.sfs.GeometryFactory.createGeometryFromGeoJson(geometryObj,srcSpatialReference);
                        }
                    }catch(e){
                    }
                }
                else{
                    var x,y;
                    x=this._getXyVal(data,this.options.xField);
                    y=this._getXyVal(data,this.options.yField);
                    geometry=new g2.sfs.Point({x:x,y:y,spatialReference: srcSpatialReference});
                }
                //点的坐标验证
                if(geometry instanceof g2.sfs.Point){
                    var coords=GeometryUtil.validateCoordinate(geometry.x,geometry.y,srcSpatialReference);
                    if(!coords){
                        geometry=null;
                    }
                }

            }catch(e){
                LoggerUtil.warn('record '+data._id+' 没有坐标 ');
            }
            //需要转换坐标系
            if(srcSpatialReference&&destSpatialReference&&srcSpatialReference!=destSpatialReference){
                geometry=this.projService.transform(geometry,destSpatialReference);
            }
            return geometry;
        },

        _getXyVal: function(data,field){
            var val;
            try{
                if(field.indexOf('.')<0){
                    val=data[field];
                }else{
                    val=parseFloat(eval('data.'+field));
                }
            }catch(e){}
            return val;
        },
        /**
         * 根据数据获取对应的符号
         * @method
         * @param {Object} dataObj - 必填，数据对象
         * @param {Number} zoom - 可选，地图级别
         * @returns {Object} -
         * obj.symbol=symbol;
         * obj.zoomRange:用于判断比例尺变化时是否需要更新符号;
         * 默认为false，表示符号不随比例尺更新；
         * 为某个范围，如[0-2]表示该符号是[0-2]比例尺范围的符号；
         * obj.zoomRanges: 不同台比例尺范围对应的所有符号配置;
         */
        getSymbol:function(dataObj,zoom){
            return this._getSymbol(dataObj,zoom);
        },
        /**
         * 根据数据获取对应的符号
         * @method
         * @param {Object} dataObj - 必填，数据对象
         * @param {Number} zoom - 可选，地图级别
         * @returns {Object} -
         * obj.symbol=symbol;
         * obj.zoomRange:用于判断比例尺变化时是否需要更新符号;
         * 默认为false，表示符号不随比例尺更新；
         * 为某个范围，如[0-2]表示该符号是[0-2]比例尺范围的符号；
         * obj.zoomRanges: 不同台比例尺范围对应的所有符号配置;
         */
        _getSymbol:function(dataObj,zoom){
            var data;
            zoom=this._getSymbol_Zoom(zoom);
            data=this._getSymbol_DataObj(dataObj,this.options.attributeField);
            data=this._getDataOrData2(data,dataObj);//data=data||dataObj;
            //根据数据获取对应字段值的渲染符号key值
            var symKeyObj=this._getSymbol_symKeyObj(this.renderFields,data);
            var symKey=symKeyObj.symKey;
            var rangeStr=symKeyObj.rangeStr;
            symKey=this._getSymbol_symKeyLookstr(symKey,'$_$');
            //k=0为默认符号
            //获取匹配的符号；
            var k=1,
                len=this.allSymbols.length,
                _symbolObj,
                zoomRangeStr,//当前比例尺级别范围
                zoomRanges=[];//所有比例尺级别范围
            for(;k<len;k++){
                var symbolObj=this.allSymbols[k];
                if(symbolObj){
                    var symbolKey=symbolObj.symbolKey;
                    if(symbolKey==symKey){
                        _symbolObj=symbolObj;
                        break;
                    }else if(symbolKey.startsWith(symKey)){
                        if(symbolKey.indexOf('zoomLevel$=$')>=0){
                            var arr=symbolKey.split('$_$');
                            var rangeStr=arr[arr.length-1].split('$=$')[1];
                            if(CommonUtil.assertWithin(zoom,rangeStr)){
                                zoomRangeStr=rangeStr;
                                _symbolObj=symbolObj;
                            }
                            //记录所有的比例尺范围;no break clause;
                            zoomRanges.push(rangeStr);
                        }
                    }
                }
            }
            //匹配多个符号，则是根据比例尺渲染
            var config=this.symbolConfig,
                defaultSym=config.defaultSymbol,
                resultObj={};
            if(_symbolObj){//
                var symbol=this._doGetSymbol(data,_symbolObj,defaultSym);
                resultObj={
                    symbol:symbol,
                    //当前符号的比例尺范围
                    zoomRange:zoomRangeStr,
                    zoomRanges:zoomRanges,
                    symbolKey:_symbolObj.symbolKey
                };
            }else{
                var symbol=this._doGetSymbol(data,config,defaultSym);
                // console.log('using default symbol;');
                resultObj= {
                    symbol:symbol,
                    zoomRange:false,
                    symbolKey:this.options.defaultSymbolKey
                }
            }
            return resultObj;
        },
        /**
         * 获取高亮图标
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {String} elementId - 必填，元素的id
         * @returns {g2.sfs.Symbol}
         */
        getHighlightSymbol:function(elementId){
            var hlSym=null;
            var sym=this.getElementSymbol(elementId);
            if(sym){
                var hlConfig=this.symbolConfig.highlight;
                if(hlConfig){//这里根据配置设置新的符号
                    hlSym=this._generateNewSymbol(sym,hlConfig);
                }
            }
            return hlSym;
        },

        /**
         * 更新图标
         * @method
         * @private
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Number} zoom - 必填，地图级别
         */
        updateSymbol:function(zoom){
            try{
                // var d1=new Date();
                var eles,updateCount=0;
                eles=this.elements;
                for(var i=0,len=eles.length;i<len;i++){
                    var ele=eles[i];
                    if(ele._zoomRange===false){
                        continue;
                    }
                    var symbolObj=this._getSymbol(ele._data,zoom);
                    if(symbolObj.zoomRange===ele._zoomRange){
                        continue;
                    }
                    ele.symbol=symbolObj.symbol;
                    this.layer.update(ele,true);
                    //更新符号地图级别范围
                    ele._zoomRange=symbolObj.zoomRange;
                    ele._symbolKey=symbolObj.symbolKey;
                    //
                    updateCount++;
                }
                //notify symbol updated
                if(updateCount>0){
                    this._onSymbolsUpdated();
                }
            }catch(e){
                LoggerUtil.error(e);
            }

        },
        /**
         * 批量移除元素
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Array} elementArr - 必填，要移除的元素数组
         */
        removeElements:function(elementArr){},

        /**
         * 设置元数据
         * @method
         * @private
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Object} metaData - 必填，元数据
         */
        setMetaData:function(metaData){
            this.metaData=metaData||{};
        },
        /**
         * 检查几何数据有效性
         * @method
         * @param {g2.sfs.Geometry} geometry - 必填
         * @returns {Boolean}
         */
        validateGeometry:function(geometry){
            if(!geometry){
                return false;
            }
            if(geometry instanceof g2.sfs.Point){
                if(isNaN(geometry.x)||isNaN(geometry.y)){
                    return false;
                }
                // if(geometry.x<=0||geometry.y<=0){
                //     return false;
                // }
            }//else if(geometry instanceof g2.sfs.Polyline g2.sfs.Polygon)
            return true;
        },
        /**
         * 清除
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         */
        destroy:function(){
            this.clear();
            //
            BaseLayer.prototype.destroy.call(this);
        }
    });

    /**
     *
     */
    layer.include({
        /**
         * 根据id获取元素
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param eleId - 必填，元素id
         * @returns {*}
         */
        getElementById:function(eleId){
            var object=this._getLayerElementById(this.layer,eleId);
            if(object){
                return object.element;
            }else{
                return null;
            }
        },

        /**
         * 获取指定元素的符号；如果不存在或者符号为空 返回null
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {String} id - 必填，元素的id
         * @returns {g2.sfs.Symbol}
         */
        getElementSymbol:function(id){
            var key,ele,
                elements=this.elements;
            for(key in elements){
                var element=elements[key];
                if(element.id==id){
                    ele=element;
                }
            }
            if(ele){
                if(ele.symbol){
                    return ele.symbol;
                }
            }
            return null;
        },

        /**
         * 获取符号尺寸
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {g2.sfs.Symbol} symbol - 必填
         * @returns {Object}
         */
        getSymbolSize:function(symbol){
            var size=[];
            if(symbol instanceof g2.sfs.SimpleMarkerSymbol){
                size.push(symbol.size*2);
                size.push(symbol.size*2);
                size.push(symbol.offsetX||0);
                size.push(symbol.offsetY||0);
            }else if(symbol instanceof g2.sfs.PictureMarkerSymbol){
                size.push(symbol.width);
                size.push(symbol.height);
                size.push(symbol.offsetX||0);
                size.push(symbol.offsetY||0);
            }
            return size;
        },
        /**
         * 清空图层
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         */
        clear:function(){
            //
            this.layer.clear();
            if(Object.prototype.hasOwnProperty.call(this,'elements')){
                this.elements=[];
            }else if(Object.prototype.hasOwnProperty.call(this,'features')){
                this.features=[];
            }
            //notify symbol updated
            this._onSymbolsUpdated();
            //notify elements changed
            this._onElementChanged();
            //
            delete this.noneSpatialArr;
            this.noneSpatialArr=[];
        },
        /**
         * 获取图层
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @returns {Object}
         */
        getLayer:function(){
            return this.layer;
        },
        /**
         * 获取图层id
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @returns {String}
         */
        getLayerId:function(){
            if(this.layer&&this.layer.getLayerId){
                return this.layer.getLayerId();
            }
        },
        /**
         * 获取显隐
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @returns {Boolean}
         */
        getVisible:function(){
            return this.layer.visible;
        },
        /**
         * 控制显隐
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Boolean} visible
         */
        setVisible:function(visible){
            this.layer.setVisible(visible||false);
            //更新图例
            if(visible){
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:this.currentSymbols
                });
            }else{
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:[]
                });
            }
        },
        /**
         * 获取图层名称
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @returns {String}
         */
        getLayerName:function(){
            return this.layer.getLayerName();
        },
        /**
         * 获取图层类型
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @returns {String}
         */
        getLayerType:function(){
            return this.layer.getLayerType();
        },
        /**
         * 根据id查找元素
         * @method
         * @private
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {String} id 必填
         * @returns {Object} g2.sfs.Element or g2.carto.Feature
         */
        find:function(id){
            var layer=this.getLayer();
            var ele=null;
            if(layer instanceof g2.carto.GroupLayer){
                var groupLayers=layer.groupLayers;
                for(var i=0,len=groupLayers.length;i<len;i++){
                    var ll=groupLayers[i];
                    if(ll&&ll.find){
                        var element=ll.find(id);
                        if(element){
                            ele=element;
                            break;
                        }
                    }
                }

            }else{
                ele=layer.find(id);
            }
            return ele;
        },
        /**
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @returns {Array}
         */
        getElements:function(){
            return this.elements;
        },
        /**
         * 地图点击事件
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Number} screenX - 必填，元素的id
         * @param {Number} sreenY - 必填，元素的id
         * @returns {Function}
         */
        hitTest:function(screenX, sreenY){
            return this.layer.hitTest(screenX, sreenY);
        }
    });
    //获取符号相关的方法集合
    layerExtend.includeGetSymbol(layer);
    //查询元素相关集合方法
    layerExtend.includeFindElementById(layer);
    //根据符号和配置生成新符号对象的相关的方法集合
    layerExtend.includeGenerateNewSymbol(layer);
    //解析符号配置文件
    layerExtend.includeParseSymbolCfg(layer);

    return layer;
});
